import { Component, OnInit, EventEmitter } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { Jsonp } from '@angular/http';
import { Router } from '@angular/router';
import { MatInputModule, MatSnackBar } from '@angular/material';
import { AuthenticationService, LoadingService } from '../_shared/services';
import { LoginData } from '../_shared/models';
import { CustomSnackbarComponent } from '../_shared/layout';
import { errorMessages } from '../_shared/validators';

@Component({
  templateUrl: 'login.component.html',
  styleUrls: ['../../assets/css/core-login.css', '../../assets/css/login.css']
})
export class LoginComponent implements OnInit {
  private authenticationForm: FormGroup;
  private globalErrorMessage: Object = null;
  private errorMessage = errorMessages;
  private data: LoginData;

  constructor(
    private authenticationService: AuthenticationService,
    private loadingService: LoadingService,
    private router: Router,
    public snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.authenticationForm = new FormGroup({
      userNameControl: new FormControl(null, [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(20)
      ]),
      passwordControl: new FormControl(null, [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(20)
      ])
    });

    this.authenticationService.loginState.subscribe(state => {
      if (state === true) {
        this.router.navigate(['/dashboard']);
      }
    });
    this.load(false);
  }

  load(value: boolean) {
    this.loadingService.setLoadingState(value);
  }

  Login() {
    const loginForm = this.authenticationForm.value;
    if (!this.authenticationForm.invalid) {
      this.load(true);

      this.data = {
        username: loginForm.userNameControl,
        password: loginForm.passwordControl
      };

      const self = this;
      this.authenticationService
        .login(self.data)
        .then(function(result) {
          if (result.success === true) {
            console.log('Navigating to dashboard');
            console.log('is first time ', result.data.isFirstTime);
            if (result.data.isFirstTime) {
              self.router.navigate(['/legalagreement']);
            } else {
              self.router.navigate(['/dashboard']);
            }
          } else {
            self.load(false);
            self.globalErrorMessage = result.errors;
            let data = {
              type: 'error',
              message: result.errors.userNameControl
            };
            self.snackBar.openFromComponent(CustomSnackbarComponent, {
              data: data,
              duration: 5000
            });
            self.authenticationForm.markAsPristine();
          }
        })
        .catch(function(err) {
          self.load(false);
          self.globalErrorMessage = err;
        });
    }
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/login/login.component.ts